<template>
  <div>
      <a class="btn btn-primary btn-lg" :href="embedderScript">
        just bookmark it!
      </a>
  </div>
</template>

<script>
/* eslint no-useless-escape: 0 */
export default {
  name: "Bookmarklet",
  computed: {
    embedderScript() {
        function bookmarklet() {
            const title = encodeURIComponent(document.getElementsByTagName("title")[0].innerHTML);
            const currentUrl = encodeURIComponent(window.location.href);
            const bookmarkletVersion = process.env.VUE_APP_BOOKMARKLET_VERSION;

            function getMetaContent(name) {
                const meta = document.querySelectorAll('meta[name="'+ name +'"], meta[property="'+name+'"]');
                return Array.from(meta).map(m => m.content || "").filter(Boolean);
            }

            /* Collect keywords from different sources */
            let rawKeywords = [];

            /* meta keywords */
            rawKeywords.push(...getMetaContent("keywords").flatMap(c => c.split(/,|\s+/)));

            /* opengraph and twitter */
            ["og:tags", "article:tag", "twitter:data1", "twitter:data2"].forEach(tag => {
                rawKeywords.push(...getMetaContent(tag).flatMap(c => c.split(/\s+/)));
            });

            /*  Normalize (lowercase, strip punctuation, remove empties) */
            rawKeywords = rawKeywords
                .map(w => w.toLowerCase().replace(/[^\p{L}0-9 _]/ug, "").trim())
                .filter(Boolean);

            /* Count frequencies */
            const freq = {};
            rawKeywords.forEach(word => {
                freq[word] = (freq[word] || 0) + 1;
            });

            /* Sort by frequency, get top 10 */
            const sorted = Object.entries(freq)
                .sort((a, b) => b[1] - a[1])
                .slice(0,10)
                .map(([word]) => word);

            const previewImageUrl = getMetaContent("og:image") || getMetaContent("twitter:image");
            const formUrl = process.env.VUE_APP_FRONTEND_URL
                + '/embeddedForm/?title=' + title
                + '&url=' + currentUrl
                + '&bookmarkletVersion=' + bookmarkletVersion
                + '&suggestedTags=' + JSON.stringify(sorted)
                + '&previewImageUrl=' + previewImageUrl;
            window.open(formUrl, '', 'width=1007, height=442')
        }

        return `javascript:(${bookmarklet.toString()})()`;
    }
  }
}
</script>

<style scoped>

</style>
